export default __webpack_public_path__ + "static/media/258.825d11c6.jpg";